import styled from '@emotion/styled';
import { Tabs } from '@mui/material';
import { colors } from 'theme/colors';

const StyledTabs = styled(Tabs)`
  margin-top: 10px;
  min-height: 34px;

  & button {
    padding-bottom: 0;
    text-transform: capitalize;
    color: ${colors.blue600};
    min-height: 57px;

    svg {
      margin-top: 6px;
      margin-right: 6px;
      font-size: 20px;
    }
  }
`;

export { StyledTabs };
